/**
 * 检查平台环境信息
 */

// 1. 浏览器环境
function getBrowserEnv() {
  /* 这段代码判断有问题:
    window.browser 绝大多数情况下是 undefined,所以 browser变量 会赋值为{version:{mobile:true}}
    根本没有 ios 和 android 字段, 无法区分这俩平台
    只能根据 useragent 区分出来微信和支付宝平台
    (目前项目也只是使用 env.wx or env.alipay 来判断显不显示header)

    已知一部 iOS15 的手机浏览器window.browser返回的对象含 webpagenamespace,webpageruntime相关字样
    不为undefined, 但不含versions
    因此判断browser.versions.mobile报错,导致白屏不展示页面

    针对不含 versions 字段的情况,直接使用 env.h5
   */
  const browser = window.browser || {
    versions: {
      mobile: true
    }
  }
  const env = {}
  if (browser.versions === undefined) {
    env.h5 = true;
  } else if (browser.versions.mobile) { // 判断是否是移动设备打开。browser代码在下面
    var ua = window.navigator.userAgent.toLowerCase();// 获取判断用的对象
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      // 微信内的浏览器
      env.wx = true
    } else if (browser.versions.ios) {
      // ios App?
      env.ios = true
    } else if (browser.versions.android) {
      // android App?
      env.android = true
    } else if (/AlipayClient/i.test(ua)) {
      env.Alipay = true
    } else {
      // 手机浏览器应用内
      env.h5 = true
    }
  } else {
    // pc 网站
    env.pc = true
  }
  return env
}

export const browserEnv = getBrowserEnv()

// 内嵌App中
export function isApp() {

}
